import { Create, SimpleForm } from "react-admin";
import { SadaratFormFields } from "./SadaratFormFields";

export default function SadaratsCreate() {
  return (
    <Create redirect="list">
      <SimpleForm>
        <SadaratFormFields />
      </SimpleForm>
    </Create>
  );
}
